import { mergeCatalogs } from './catalog.js';
import { isRtlLocale } from './locale.js';
import { loadLocaleCatalog } from './loaders.js';
import { pluralCategory, pluralKey } from './plural.js';
const PLACEHOLDER_RE = /\{(\w+)\}/g;
function interpolate(template, params) {
    if (!params)
        return template;
    return template.replace(PLACEHOLDER_RE, (_match, name) => {
        const value = params[name];
        return value === undefined ? `{${name}}` : String(value);
    });
}
export class I18n {
    locale;
    catalog;
    fallback;
    listeners = new Set();
    constructor(locale, catalog, fallback) {
        this.locale = locale;
        this.catalog = catalog;
        this.fallback = fallback;
    }
    /** Looks up `key` with optional `{placeholder}` interpolation. */
    t(key, params) {
        const template = this.catalog[key] ?? this.fallback[key] ?? key;
        return interpolate(template, params);
    }
    /**
     * Plural-aware lookup. Resolves `baseKey.<category>` for the active locale,
     * falling back to `other` then English.
     */
    tp(baseKey, count, params) {
        const category = pluralCategory(this.locale, count);
        const merged = { count, ...params };
        const key = pluralKey(baseKey, category);
        if (this.catalog[key] ?? this.fallback[key]) {
            return this.t(key, merged);
        }
        return this.t(pluralKey(baseKey, 'other'), merged);
    }
    /** Loads a locale catalog asynchronously and switches the active locale. */
    async setLocale(locale) {
        if (locale === this.locale)
            return;
        const loaded = await loadLocaleCatalog(locale);
        this.catalog = mergeCatalogs(this.fallback, loaded);
        this.locale = locale;
        for (const listener of this.listeners)
            listener(locale);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    getLocale() {
        return this.locale;
    }
    getDir() {
        return isRtlLocale(this.locale) ? 'rtl' : 'ltr';
    }
}
//# sourceMappingURL=translator.js.map